// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1194014f","732":"eccdf34d","977":"c2ce833c"}[chunkId] + ".chunk.js";
};